import { render } from "./supplyList.vue?vue&type=template&id=3637b645"
import script from "./supplyList.vue?vue&type=script&lang=js"
export * from "./supplyList.vue?vue&type=script&lang=js"

import "./supplyList.vue?vue&type=style&index=0&id=3637b645&lang=scss"

import exportComponent from "/home/pages/train-manage/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__